var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: {
        transition: false,
        persistent: _vm.pending,
        "max-width": _vm.maxWidth,
      },
      on: {
        "click:outside": function ($event) {
          !_vm.pending ? _vm.cancel() : () => {}
        },
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", { staticClass: "headline" }, [
            _vm._v(_vm._s(_vm.title)),
          ]),
          _c(
            "v-card-text",
            [
              _vm._t("default", function () {
                return [
                  _vm.description
                    ? _c("div", [_vm._v(_vm._s(_vm.description))])
                    : _vm._e(),
                ]
              }),
            ],
            2
          ),
          _c(
            "v-card-actions",
            [
              _vm._t(
                "actions",
                function () {
                  return [
                    _c("v-spacer"),
                    _c(
                      "v-btn",
                      {
                        attrs: {
                          text: "",
                          color: "grey darken-2",
                          disabled: _vm.pending,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.cancel()
                          },
                        },
                      },
                      [_vm._v(" отмена ")]
                    ),
                    _c(
                      "v-btn",
                      {
                        attrs: {
                          text: "",
                          color: "error darken-2",
                          disabled: _vm.pending,
                          loading: _vm.pending,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.confirm()
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.confirmText) + " ")]
                    ),
                  ]
                },
                {
                  cancel: _vm.cancel,
                  confirm: _vm.confirm,
                  close: _vm.close,
                  pending: _vm.pending,
                }
              ),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }